<template>
    <div class="HomePageStyle">
        <div class="collect_box">
            <div style="width:900px;margin:0px auto 30px;">
                <h2 style="font-size:20px; color:#333;">书目导入</h2>
            </div>
            <el-row class="steps">
                <el-steps :active="4" align-center>
                    <el-step description="选择图书馆"></el-step>
                    <el-step description="选择需导入的书目文件"></el-step>
                    <el-step description="导入书目"></el-step>
                    <el-step description="导入成功"></el-step>
                </el-steps>
            </el-row>
            <el-row>
                <div>
                    <el-col :span="10" :push="2" class="form_left">
                        <el-form :model="form" label-width="130px" :rules="rules" ref="formName"
                            enctype="multipart/form-data">
                            <el-form-item label="选择图书馆：" prop="orgGid">
                                <el-select v-model="form.orgGid" filterable :filter-method="getOrgList"
                                    class="org-select">
                                    <el-option v-for="item in orgList" :key="item.gid" :label="item.orgName"
                                        :value="item.gid"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="导入文件：" class="import" prop="filePath">
                                <web-upload upload_button=".btns" :headers="headers" :cdn-url="url" :auto="auto_flag"
                                    :fileSingleSizeLimit="limitSize" @success="handleSuccess" @before="handleBefore"
                                    @error="handlError" @errorserver="errorServer" ref="uploader"></web-upload>
                                <div class="btns form-btn choose-blue">选择文件</div>
                                
                                <el-input class="file-name" v-model="fileName"></el-input>
                            </el-form-item>
                            <el-form-item label="">
                                <div style="padding-top: 20px;">
                                    <el-button type="success" @click="btnSubmit('formName')">提交</el-button>
                                    <el-button type="danger" style="margin-left: 20px;" @click="btnSubmit('formName')">Marc数据下载</el-button>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span="8" :offset="4">
                        <div class="tips_s">
                            <p class="tit"><i></i> <span>温馨提醒</span></p>
                            <div>
                                <p> 1、图书馆数据来源于公共组件-图书馆；</p>
                                <p> 2、支持txt文件导入；</p>
                                <p> 3、导入时不与三新书目库匹配，直接导入即可；</p>
                                <p> 4、上传书目，大小不超过"50M",上传如果超过限制，提示"文件上传不能超过50M！"</p>
                            </div>
                        </div>
                    </el-col>
                </div>
                <!-- <div v-else>
                    <successful :successCount="successCount" uploadType="library" @back="backLibrary"></successful>
                    <div class="import-data-table">
                        <h3>导入数据预览</h3>
                        <el-table :data="importedBooks" style="width: 100%" border>
                            <el-table-column prop="classNumber" label="分类号" width="120"></el-table-column>
                            <el-table-column prop="publisher" label="出版社名称" width="180"></el-table-column>
                            <el-table-column prop="author" label="作者" width="120"></el-table-column>
                            <el-table-column prop="summary" label="内容简介"></el-table-column>
                        </el-table>
                    </div>
                </div> -->
            </el-row>
        </div>
    </div>
</template>

<script>
    import { Loading, Message } from 'element-ui'
    // import { getUserInfo } from 'libs/utils/localStorage.js'
    // import message from 'common/utils/message'
    import WebUpload from '../../common/plugin/webupload/index.vue'
    import successful from './Successful'
    import { actionsearch, orgactionsearch } from '@/api/authority'

    export default {
        data() {
            let t = this;
            var checkfile = (rule, value, callback) => {
                if (value.length == 0) {
                    callback(new Error('导入文件不能为空'));
                } else {
                    callback();
                }
            };
            var checkselect = (rule, value, callback) => {
                if (value.length == 0) {
                    callback(new Error('书商不能为空'));
                } else {
                    callback();
                }
            };
            return {
                form: {
                    filePath: '',
                    orgGid: ''
                },
                orgList: [],
                value: '',
                optionValue: [],
                url: `/sxtucaihui/userlogin/action/saveBatchCollection`,
                //单个文件大小限制
                limitSize: 1024 * 1024 * 50,
                props: {
                    label: 'booksellerName',
                    value: 'gid',
                    children: 'bookSellerInfoList'
                },
                headers: {
                },
                rules: {
                    filePath: [
                        { required: true, validator: t.validateFile }
                    ],
                    orgGid: [
                        { required: true, message: '请选择图书馆！', trigger: 'change' }
                    ]
                },
                fileName: '',
                importFlag: false, //导入成功是否
                successCount: '',//导入成功的条数
                uploader: null, //上传对象,
                auto_flag: false, //是否自动上传，
                loading: null,

                
            }
        },
        components: {
            successful, WebUpload,
        },
        created() {
            let vm = this;
            let user = JSON.parse(localStorage.getItem('user'));
            if (user) {
                vm.headers.userId = user.userId;
                vm.headers.token = user.token;
            }
        },
        computed: {
        },
        mounted() {
            let vm = this;
            vm.getOrgList()
        },
        methods: {
            /* 验证上传文件的方法**/
            validateFile: function (rule, value, callback) {
                if (!this.fileName) {
                    callback(new Error('请选择要上传的文件'));
                } else {
                    let regCn = /[%&￥#@]/im;
                    let fileType = this.fileName.split('.');
                    fileType = fileType[fileType.length - 1].toLowerCase();
                    if (regCn.test(this.fileName)) {
                        callback(new Error('上传文件名不能包含”%&￥#@“等特殊字符！'));

                    } else if (fileType != "xls" && fileType != "xlsx" && fileType != "iso" && fileType != "txt") {
                        callback(new Error('上传文件仅支持excel,iso,txt格式！'));
                    } else {
                        callback();
                    }
                }
            },

            getOrgList(orgName, orgGid) {//机构列表获取
                let vm = this;
                return new Promise(resolve => {
                    const param = {
                        orgType: 1,
                        orgName: orgName,
                        pageSize: 10,
                        pageNum: 1,
                    }
                    orgactionsearch(param).then(res => {
                        if (res.code == '200') {
                            let r = res.data.list;
                            vm.orgList = r;
                            if (orgGid && r.length > 0) {
                                vm.form.orgGid = orgGid;
                            }
                        }
                        resolve()
                    })
                });
            },
            getOptionValue(value) {
                let vm = this;
                vm.selelctValue = value;
            },
            handleChange(file, fileList) {
                this.form.fileList = fileList.slice(-3);
            },
            btnSubmit(name) {
                let vm = this;
                vm.$refs[name].validate((valid) => {
                    if (valid) {
                        vm.importBookSellerList();
                    } else {
                        return false;
                    }
                });
            },
            //导入书单
            importBookSellerList() {
                let vm = this;
                vm.loading = Loading.service({
                    lock: true,
                    text: '正在导入中···',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                vm.$refs.uploader.toUpload(vm.form);
            },
            handleSuccess(file, res) {  //上传文件成功后
                let vm = this;
                vm.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                    vm.loading.close();
                    if (res.status) {
                        vm.importFlag = true;
                        vm.successCount = res.data.num;
                    } else {
                        vm.$message({
                            message: res.msg || res.TokenCodeDel,
                            type: 'error'
                        })
                        // message.info({ message: res.msg });
                    }
                });
            },
            handleBefore(file, uploader) {  //当有文件被添加进队列的时候
                let vm = this
                vm.fileName = file.name;
            },
            handlError(errorMessage) {//上传报错
                let vm = this;
                vm.$message({
                    message: errorMessage,
                    type: 'error'
                })
                // message.info({ message: errorMessage });
            },
            errorServer(file, response) {
                let vm = this;
                vm.loading.close();
                let user = JSON.parse(localStorage.getItem('user'));
                if (user == null || user.token == undefined) {
                    location.assign('/login.html');
                } else {
                    vm.$message({
                        message: '导入失败！',
                        type: 'error'
                    })
                    // message.info({ message: '导入失败' });
                }
            },
            //返回馆藏列表
            backLibrary(flag) {
                let vm = this;
                vm.importFlag = flag;
                vm.form = {
                    filePath: '',
                    orgGid: ''
                }
            }
        },
    };
</script>

<style lang='scss'>
    // @import "src/style/common";

    .collect_box {
        margin: 20px auto 0;
        padding: 20px 14px;
        background: #fff;
        border-radius: 4px;
        width: 1200px;
        min-height: 700px;

        .form-btn {
            display: inline-block;
            width: 78px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            color: #fff;
            font-size: 12px;
            border-radius: 2px;
            -moz-border-radius: 2px;
            -webkit-border-radius: 2px;
            cursor: pointer;
        }

        .choose-blue {
            background: url('../../assets/images/formbtn4.png');
            border: 1px solid #378de6;

            .el-upload--picture-card:hover,
            .el-upload:focus {
                color: #fff;
            }

            .el-upload-list {
                position: absolute;
                top: -5px;
                left: 85px;

                .el-upload-list__item {
                    font-size: 12px;
                }
            }

            .webuploader-pick {
                display: block;
                padding: 0;
                background-color: transparent;
                color: #fff;
                text-align: center;
                border: 0 none;
            }
        }

        .steps {
            width: 996px;
            margin: 40px auto;

            .el-step__head.is-finish {
                color: #69c33c;
                border-color: #69c33c;
            }

            .el-step.is-center .el-step__description {
                padding-left: 15%;
                padding-right: 15%;
                color: #333;
                margin-top: 15px;
            }
        }

        .form_left {
            margin-top: 60px;

            .m_info {
                display: block;
                line-height: 20px;
                color: #999;
                font-size: 12px;
            }

            .el-form-item__label {
                line-height: 25px;
                color: #333;
                font-size: 12px;
            }

            .el-form-item__content {
                line-height: 28px;

                .el-form-item__label {
                    color: #333;
                    font-size: 12px;
                }

                .el-input {
                    font-size: 12px;

                    .el-input__inner {
                        border-color: #b6d5f1;
                        line-height: 28px;
                        height: 28px;
                    }

                    .el-input__icon {
                        line-height: 28px;
                    }
                }

                .el-select {
                    width: 100%;
                }

                .file-name {
                    width: 285px;

                    .el-input__inner {
                        border: none;
                    }
                }
            }
        }

        .button_box {
            text-align: center;
            margin-top: 100px;
        }

        .el-cascader--medium {
            width: 100%;
            line-height: 25px;

        }

        .el-cascader-menu__item {
            font-size: 12px;
        }

        .tips_s {
            margin-top: 40px;
            width: 316px;
            height: 260px;
            font-size: 12px;
            background: #fefde1;
            color: #39382a;
            float: left;
            padding: 30px 40px 20px;
            background-size: 352px 295px;
            position: relative;

            p {
                line-height: 1.8;
            }

            .tit {
                i {
                    display: inline-block;
                    width: 23px;
                    height: 23px;
                    background: url("../../assets/images/icon2.png") no-repeat;
                    background-position: -89px -53px;
                    position: absolute;
                    left: 8px;
                    top: 28px;
                }

                span {
                    display: inline-block;
                    border: 1px solid #ff9d00;
                    height: 18px;
                    padding: 0px 5px 0px 10px;
                    line-height: 18px;
                    border-radius: 5px;
                    margin-left: -15px;

                }
            }
        }
    }
</style>

<style lang='scss'>
    .import-data-table {
        margin: 30px auto;
        width: 90%;
        
        h3 {
            font-size: 16px;
            color: #333;
            margin-bottom: 15px;
            padding-left: 10px;
            border-left: 4px solid #69c33c;
        }
        
        .el-table {
            margin-bottom: 20px;
            
            th {
                background-color: #f5f7fa;
                color: #333;
                font-weight: bold;
            }
            
            .el-table__row:hover {
                background-color: #f0f9eb;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/ImportMarc/index.vue